document.addEventListener('DOMContentLoaded', function () {

     const entregaEl = document.querySelector(".prazo-entrega");
    if (!entregaEl) return;

    const daysEl = entregaEl.querySelector(".prazo-entrega-days");
    if (!daysEl) return;

    const leapDaysAttr = entregaEl.dataset.leapDays;
    const prazoEntregaAttr = daysEl.dataset.prazoEntrega;

    if (!leapDaysAttr || !prazoEntregaAttr) return;

    const leapDays = parseInt(leapDaysAttr, 10);
    const prazoEntrega = parseInt(prazoEntregaAttr, 10);

    if (isNaN(leapDays) || isNaN(prazoEntrega)) return;

    const hoje = new Date();

    // Função para adicionar dias úteis (ignora sábados e domingos)
    function adicionarDiasUteis(data, dias) {
      const novaData = new Date(data);
      let adicionados = 0;

      while (adicionados < dias) {
        novaData.setDate(novaData.getDate() + 1);
        const diaSemana = novaData.getDay();
        if (diaSemana !== 0 && diaSemana !== 6) {
          adicionados++;
        }
      }

      return novaData;
    }

    // Pula se a data final cair num sábado ou domingo
    function pularFimDeSemana(data) {
      const novaData = new Date(data);
      const diaSemana = novaData.getDay();
      if (diaSemana === 6) {
        novaData.setDate(novaData.getDate() + 2); // sábado → segunda
      } else if (diaSemana === 0) {
        novaData.setDate(novaData.getDate() + 1); // domingo → segunda
      }
      return novaData;
    }

    // Meses abreviados
    const mesesAbreviados = [
      "jan.", "fev.", "mar.", "abr.", "mai.", "jun.",
      "jul.", "ago.", "set.", "out.", "nov.", "dez."
    ];

    function formatarData(data) {
      const dia = data.getDate();
      const mes = mesesAbreviados[data.getMonth()];
      return `<b>${dia} de ${mes}</b>`;
    }

    // Calcula datas ignorando finais de semana
    const dataInicio = adicionarDiasUteis(hoje, leapDays);
    const dataFimRaw = adicionarDiasUteis(dataInicio, prazoEntrega);
    const dataFim = pularFimDeSemana(dataFimRaw);

    // Insere no HTML
    daysEl.innerHTML = `${formatarData(dataInicio)} e ${formatarData(dataFim)}`;

    let showOpened = false;
    let imgSrc = '';
    let imgTitle = '';

    function resizeThumbs() {
        const contentThumbs = document.querySelector('#product-photo');
        const imgThumb = document.querySelector('#product-photo img');
        if (contentThumbs && imgThumb) {
            let heightImg = imgThumb.getBoundingClientRect().height;
            contentThumbs.style.minHeight = heightImg + 'px';
        }
    }

    function clickThumbs() {
        let photoArea = document.querySelector('.product-detail__header--photoArea');
        let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

        if (photoThumbs && photoArea) {
            if (photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                let photoListItem = document.querySelectorAll('#photo-list li');
                let singlePhotoItem = document.querySelectorAll('#product-photo img, #product-photo video');

                if (photoListItem.length && singlePhotoItem.length) {
                    photoListItem[0].classList.add('active');
                    singlePhotoItem[0].classList.add('active');

                    function activeTab(index) {
                        photoListItem.forEach((item) => item.classList.remove('active'));
                        singlePhotoItem.forEach((content) => content.classList.remove('active'));
                        photoListItem[index].classList.add('active');
                        singlePhotoItem[index].classList.add('active');
                    }

                    photoListItem.forEach((itemMenu, index) => {
                        itemMenu.addEventListener('click', () => activeTab(index));
                    });
                }
            }
        }

        if (photoThumbs && photoArea) {
            if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                $('#product-photo').slick({
                    swipeToSlide: true,
                    touchThreshold: 100,
                    arrows: false,
                    dots: false,
                    infinite: false,
                    mobileFirst: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    speed: 300,
                });

                let photoListItems = document.querySelectorAll('#photo-list li');

                if (photoListItems.length) {
                    photoListItems.forEach((item, index) => {
                        item.addEventListener('click', function () {
                            photoListItems.forEach(li => li.classList.remove('active'));
                            this.classList.add('active');

                            const slidesToShow = 2;
                            const totalItems = photoListItems.length;
                            const lastSlideIndex = Math.max(0, totalItems - slidesToShow);
                            const slideIndex = Math.min(index, lastSlideIndex);

                            $('#product-photo').slick('slickGoTo', slideIndex);
                        });
                    });

                    if (photoListItems[0]) {
                        photoListItems[0].classList.add('active');
                    }
                }
            }
        }

        if (photoArea && photoArea.classList.contains('gallery-scroll')) {
            let productPhoto = document.querySelector('#product-photo');
            let productImage = productPhoto.querySelector('img');
            let imageHeight = productImage ? productImage.getBoundingClientRect().height : 0;
            productPhoto.style.maxHeight = imageHeight + 'px';

            let thumbsContainer = document.querySelector('.product-detail__header--photoArea-thumbs');
            if (thumbsContainer) {
                thumbsContainer.style.maxHeight = imageHeight + 'px';
            }

            let thumbsLarge = document.querySelectorAll('#product-photo a');
            let miniThumbs = document.querySelectorAll('.product-detail__header--photoArea-thumbs #photo-list li');
            if (thumbsLarge.length && miniThumbs.length) {
                miniThumbs.forEach((thumb, index) => {
                    thumb.addEventListener('click', () => {
                        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                        const target = thumbsLarge[index];
                        if (target) {
                            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    });
                });
            }
        }
    }

    function updateImageThumb(src) {
        imgSrc = src;
    }

    function handleESC(event) {
        if (event.key === 'Escape') {
            showOpened = false;
            const showcase = document.querySelector('.js-showcase, .showcase, [data-showcase]');
            if (showcase) showcase.classList.remove('active');
        }
    }

    function checkBuyView() {
        const buyButton = document.getElementById('buy-button');
        if (!buyButton) return;
        const rect = buyButton.getBoundingClientRect();
        const fixedBuy = document.querySelector('.product-detail__fixed--buy');
        if (!fixedBuy) return;

        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
            fixedBuy.classList.remove('active');
        } else {
            fixedBuy.classList.add('active');
        }
    }

    function zoom(event) {
        const container = document.getElementById('zoom-container');
        const image = document.getElementById('zoom-image');
        if (!container || !image) return;

        const containerRect = container.getBoundingClientRect();
        const mouseX = event.clientX - containerRect.left;
        const mouseY = event.clientY - containerRect.top;

        if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
            const zoomLevel = 1.2;
            const newWidth = container.offsetWidth * zoomLevel;
            const newHeight = container.offsetHeight * zoomLevel;

            const offsetX = -(mouseX * (zoomLevel - 1));
            const offsetY = -(mouseY * (zoomLevel - 1));

            image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

            if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
            }
            if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
            }
            if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${-(newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
            }
            if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${-(newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
            }
        }
    }

    function resetZoom() {
        const image = document.getElementById('zoom-image');
        if (image) image.style.transform = 'translate(0, 0) scale(1)';
    }

    // Expõe funções que podem ser chamadas via atributos onclick no HTML
    window.productDetail = { zoom, resetZoom, updateImageThumb };

    // --- description-nav tabs ---
    const description = document.querySelector('.description-nav');
    if (description) {
        let navTab = Array.from(description.querySelectorAll('.nav-item'));
        let navShow = Array.from(description.querySelectorAll('.description-nav-content'));

        if (navTab.length && navShow.length) {
            function toggleTab(index) {
                const isActive = navTab[index].classList.contains('active');
                navTab.forEach((content) => content.classList.remove('active'));
                navShow.forEach((content) => content.classList.remove('active'));
                if (!isActive) {
                    navTab[index].classList.add('active');
                    navShow[index].classList.add('active');
                }
            }

            navTab.forEach((itemMenu, index) => {
                itemMenu.addEventListener('click', () => toggleTab(index));
            });
        }
    }

    // --- group size title ---
    const groupSizeTitle = document.querySelector('.group-size .group-size-title');
    const productRadioVariation = document.querySelector('.product-radio-variation .label_attributes');
    if (groupSizeTitle && productRadioVariation) {
        groupSizeTitle.textContent = productRadioVariation.textContent;
    }

    // --- cupom click to copy ---
    waitForElementToExist('.price-cupom').then(() => {
        const priceCupom = document.querySelector('.price-cupom b');
        if (priceCupom) {
            const priceCupomValue = priceCupom.textContent;
            if (priceCupomValue) {
                priceCupom.addEventListener('click', (e) => {
                    e.preventDefault();
                    navigator.clipboard.writeText(priceCupomValue).then(() => {
                        alert('Valor copiado: ' + priceCupomValue);
                    }).catch(() => {
                        alert('Erro ao copiar o valor.');
                    });
                });
            }
        }
    });

    // --- foto inicial da thumb ---
    const photoList = document.getElementById('photo-list');
    if (photoList) {
        const firstLi = photoList.querySelector('li');
        if (firstLi) {
            const imgElement = firstLi.querySelector('img');
            if (imgElement) {
                imgSrc = imgElement.getAttribute('src');
                imgTitle = imgElement.getAttribute('title');
            }
        }
    }

    clickThumbs();

    // --- rating label ---
    const ratingName = document.querySelector('.product-detail__rating__amount');
    if (ratingName && ratingName.textContent === 'Seja o primeiro a avaliar') {
        ratingName.textContent = 'Avaliar';
    }

    // --- user letter avatar ---
    const userLetterElement = document.getElementById('user_letter');
    if (userLetterElement) {
        const userLetter = userLetterElement.innerText.trim();
        if (userLetter.length > 0) {
            userLetterElement.innerText = userLetter[0];
        }
    }

    document.addEventListener('keydown', handleESC, { passive: true });
    window.addEventListener('scroll', checkBuyView, { passive: true });
    window.addEventListener('load', checkBuyView, { passive: true });
});

$(document).ready(function () {

    // --- cashback abaixo do preco ---
    // A .section-cashback e injetada pela plataforma depois do ready e o bloco
    // de preco e re-renderizado ao trocar a variacao, entao observamos o DOM em
    // vez de tentar mover o elemento uma unica vez
    (function initCashbackPosition() {
        const CASHBACK_SELECTOR = '.section-cashback';
        const PRICE_SELECTOR = '#js-product_price__product_detail_';

        function moveCashback() {
            const cashBack = document.querySelector(CASHBACK_SELECTOR);
            const priceDetail = document.querySelector(PRICE_SELECTOR);

            if (!cashBack || !priceDetail) return;
            // ja esta no lugar certo, evita loop de mutation
            if (cashBack.parentElement === priceDetail) return;

            priceDetail.appendChild(cashBack);
        }

        moveCashback();

        let scheduled = false;
        const observer = new MutationObserver(function () {
            if (scheduled) return;

            // agrupa as mutations do mesmo frame numa unica verificacao
            scheduled = true;
            window.requestAnimationFrame(function () {
                scheduled = false;
                moveCashback();
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    })();

    if (document.querySelector('.carousel-kit')) {
        var splide = new Splide('.carousel-kit', {
            type: 'slide',
            height: 'auto',
            autoHeight: true,
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButtons = document.querySelectorAll('.js-btn__product_detail__add_to_cart');
            addToCartButtons.forEach(button => button.classList.add('no-buy'));

            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-actual') {
                    var actual = parseInt(nextButton.getAttribute('data-actual'));
                    var end = parseInt(nextButton.getAttribute('data-end'));
                    if (actual === end) {
                        nextButton.classList.add('no-click');
                    } else {
                        nextButton.classList.remove('no-click');
                    }
                }
            });
        });

        observer.observe(nextButton, { attributes: true, attributeFilter: ['data-actual'] });

        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }

    $('body').on('click', '.btn-group.btn-minus', function () {
        var qt_el = $(this).closest('.amount').find('.product-detail__qtd--input');
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) qtd = 1;
        if (qtd > 1) qtd--;
        qt_el.val(qtd);
    });

    $('body').on('click', '.btn-group.btn-plus', function () {
        var qt_el = $(this).closest('.amount').find('.product-detail__qtd--input');
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) qtd = 1;
        else qtd++;
        qt_el.val(qtd);
    });

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(() => {
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_SELECTOR = '#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2';

        const selectedGroups = new Set();
        const getGroups = () => Array.from(document.querySelectorAll(GROUP_SELECTOR));

        const syncUI = () => {
            const groups = getGroups();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);
            if (!addCartBtn) return;

            groups.forEach(group => {
                if (!selectedGroups.has(group.id)) {
                    group.classList.add('please-select');
                }
            });

            const allSelected = groups.length > 0 && groups.every(g => selectedGroups.has(g.id));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        const markSelected = (group) => {
            if (!group || !group.id) return;
            selectedGroups.add(group.id);
            group.classList.remove('please-select');
            syncUI();
        };

        const container = document.querySelector('#js_buy_together_api_layout_1_groups');
        if (!container) return;

        container.addEventListener('change', (e) => {
            const group = e.target.closest(GROUP_SELECTOR);
            if (group) markSelected(group);
        }, { passive: true });

        container.addEventListener('click', (e) => {
            const target = e.target;
            if (target.closest('label') || target.matches('input')) {
                const group = target.closest(GROUP_SELECTOR);
                if (group) setTimeout(() => markSelected(group), 0);
            }
        }, { passive: true });

        const observer = new MutationObserver(() => syncUI());
        observer.observe(container, { childList: true, subtree: true });

        syncUI();
    });

    let listBuyTogether = document.getElementById('js_buy_together_api_layout_1_groups');
    if (listBuyTogether) {
        var observer = new MutationObserver(Callback);
        observer.observe(listBuyTogether, { childList: true });

        function Callback() {
            const products = document.querySelectorAll('#js_buy_together_api_layout_1_groups ul');
            if (products.length) {
                products.forEach(product => {
                    if (product.dataset.buyTogetherBound) return;
                    product.dataset.buyTogetherBound = '1';

                    const options = product.querySelector('.product-item__options');
                    if (options) {
                        options.addEventListener('click', () => {
                            const radioVariation = options.querySelector('.product-radio-variation');
                            if (radioVariation) radioVariation.classList.toggle('active');
                            product.classList.toggle('active');
                        });

                        if (window.matchMedia('(max-width: 991px)').matches) {
                            const detailList = product.querySelector('.product-item__content--container');
                            if (detailList) detailList.appendChild(options);
                        }
                    }
                });
            }
        }
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType !== 1) return;

                    ['js_buy_together_api_group_1', 'js_buy_together_api_group_2'].forEach(groupId => {
                        const targetNode = node.id === groupId ? node : node.querySelector('#' + groupId);
                        if (!targetNode) return;

                        const options = targetNode.querySelector('.product-item__options');
                        const figcaption = targetNode.querySelector('.product-item__content--figcaption');
                        if (options && figcaption) figcaption.append(options);

                        const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                        const sizes = targetNode.querySelector('.product-radio-variation');

                        if (widget && sizes) {
                            widget.addEventListener('click', () => sizes.classList.toggle('active'));

                            sizes.querySelectorAll('label').forEach(size => {
                                size.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                    widget.setAttribute('data-before', size.textContent);
                                });
                            });
                        }
                    });
                });
            });
        });

        observer.observe(brinde, { childList: true, subtree: true });
    }

    const compreJunto = document.querySelector('#js_buy_together_api_layout_1');
    if (compreJunto) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType !== 1) return;

                    ['js_buy_together_api_group_0', 'js_buy_together_api_group_1', 'js_buy_together_api_group_2'].forEach(groupId => {
                        const targetNode = node.id === groupId ? node : node.querySelector('#' + groupId);
                        if (!targetNode) return;

                        const options = targetNode.querySelector('.product-item__options');
                        const figcaption = targetNode.querySelector('.info-product');
                        if (options && figcaption) figcaption.append(options);
                    });
                });
            });
        });

        observer.observe(compreJunto, { childList: true, subtree: true });
    }

    if ($('.product-detail__header--photoArea-mobile, .mobile-slider').length) {
        $('.product-detail__header--photoArea-mobile, .mobile-slider').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 300,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                },
            ]
        });
    }

    if ($('#product-detail-related-carrousel').length) {
        $('#product-detail-related-carrousel').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                },
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function () {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) {}
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();

    if ($('.product-rating__review-list').length) {
        $('.product-rating__review-list').slick({
            arrows: false,
            dots: false,
            swipeToSlide: true,
            touchThreshold: 100,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        arrows: true,
                    }
                }
            ]
        });
    }
});
